<!-- Primary outlet. -->
<router-outlet></router-outlet>

<!-- Modal outlet. -->
<router-outlet name="modal"></router-outlet>
